import { observer } from 'mobx-react-lite'
import React from 'react'
import classNames from 'classnames'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { CallInsightCardsNoteForm } from 'widgets/CallPopUp/ui/CallInsightCards/CallInsightCardsNoteForm'
import styles from './styles.module.scss'

export const CallInsightCardsNote = observer(() => {
  const { callPopUpInsightCardsStore } = useCallPopUpDefaultContext()

  return (
    <>
      <div className={styles.divider} />
      <div className={classNames(styles.tabContent, styles.note)}>
        <CallInsightCardsNoteForm store={callPopUpInsightCardsStore.callNoteStore} />
      </div>
    </>
  )
})
